import React from 'react'

const STATS = [
  {
    cls: 'statcard--a',
    big: '~63%',
    lead: 'des chiens reçoivent du fait-maison',
    body: "Une majorité de propriétaires cuisine pour leur animal, au moins en partie. La demande existe — mais l'encadrement vétérinaire manque cruellement.",
    src: 'Dodd et al., ESVCN 2018',
  },
  {
    cls: 'statcard--b',
    big: '~5%',
    lead: 'des rations maison sont complètes',
    body: "L'immense majorité des recettes trouvées en ligne ou bricolées à la maison présentent des carences graves. Sans outil, même un vétérinaire motivé passe à côté.",
    src: 'Stockman et al., JAVMA 2013',
  },
  {
    cls: 'statcard--c',
    big: '~1h → min',
    lead: "le temps d'une ration divisé",
    body: "Construire une ration équilibrée à la main peut prendre une heure. Fetchy ramène ce temps à quelques minutes, calculs et prescription inclus.",
    src: '',
  },
]

const Problem = () => (
  <section className="vt-section" id="problem">
    <div className="vt-shell">
      <div className="sec-head">
        <span className="eyebrow">Le constat</span>
        <h2>Le problème est massif.</h2>
        <p>Les propriétaires cuisinent. Les rations sont bancales. Les vétérinaires manquent d'outils.</p>
      </div>
      <div className="statcards">
        {STATS.map((s, i) => (
          <div className={`statcard ${s.cls}`} key={i}>
            <div className="statcard__big">{s.big}</div>
            <div className="statcard__lead">{s.lead}</div>
            <div className="statcard__body">{s.body}</div>
            {s.src && <div className="statcard__src">{s.src}</div>}
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default Problem
